<template>
    <div id="hero">
        <section id="hero-section">
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <div class="col-lg-10 col-sm-12">
                        <div class="row justify-content-between">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 order-lg-1 order-md-1">
                        <div class="intro-message">
                            <h1 class="h1-title">Build A Gorgeous App By Only Describing It</h1>
                            <p>SPIRITT is a human-assisted AI platform that lets you build complex apps like Airbnb, Instagram, Pinterest, and many more without any tech skills needed, With an affordable monthly price.</p>
                            <ul class="mt-5 d-flex p-0 list-unstyled">
                                <li>
                                    <router-link :to="{name: 'quiz', params: {url: formURL}}" class="btn btn-hero btn-hero-primary mr-3">Start For Free</router-link>
                                </li>
                                <li>
                                    <button v-scroll-to="'#how-it-works'" class="btn btn-hero btn-hero-secondary d-none d-lg-block">How It Works</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    // import AnimatedCircles from '../AnimatedCircles.vue';
    import posthog from 'posthog-js';

    export default {
        name: 'hero',
      data() {
        return {
          formId: 'P4Oy3x'
        }
      },
        components: {
            // 'animated-circles': AnimatedCircles,
        },
      computed: {
          formURL () {
            return posthog.getFeatureFlag('new-app-form-test')  === 'test' ? 'DWs2SKWK' : this.formId;
          }
      },
      mounted () {

      }
    }
</script>

<style lang="css" scoped>
    #hero-section {
        min-height: 100vh;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        overflow: hidden;
        color: #fff;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        content: "";
        z-index: 1;
        -webkit-box-align: center;
        -ms-flex-align: center;
        position: relative;
        background-image: linear-gradient(to right top, rgba(65, 126, 170, 0.95), rgba(51, 122, 187, 0.95), rgba(60, 115, 202, 0.95), rgba(88, 104, 211, 0.95), rgba(124, 88, 213, 0.95), rgba(136, 76, 209, 0.95), rgba(149, 61, 203, 0.95), rgba(161, 40, 196, 0.95), rgba(151, 36, 192, 0.95), rgba(140, 32, 188, 0.95), rgba(130, 29, 184, 0.95), rgba(119, 25, 180, 0.95));
        background-attachment: fixed;
        background-size: cover;
    }
    .h1-title {
        font-size: 3.5rem !important;
    }

    #hero-section:after {
        content: "";
        position: absolute;
        bottom: -100px;
        left: -50px;
        height: 200px;
        width: 130%;
        -webkit-transform: rotate(-4deg);
        -ms-transform: rotate(-4deg);
        transform: rotate(-4deg);
        z-index: 10;
        background-color: #f1f1f1;
    }
    .btn-hero {
        height: 48px;
        min-width: 240px;
        font-weight: bold;
        border-radius: 21px;
        cursor: pointer;
        font-size: 20px;
        border: none;
    }
    .btn-hero-primary, .btn-hero-primary:hover, .btn-hero-primary:focus, .btn-hero-primary:active {
        color: #ffffff;
        background-image: linear-gradient(101deg, #5b9bfb 2%, #00c092 96%) !important;
        padding-top: 10px;
        outline: none;
        border: none;
        transition: 0.3s;
    }
    .btn-hero-primary:hover {
        color: #751da7;
    }
    .btn-hero-secondary {
        color: #751da7;
        background: #fff;
    }
    .btn-hero-secondary:hover {
        color: #751da7;
        background: #e0e0e0;
    }
    @media (max-width: 780px) {
        #hero-section {
            min-height: calc(100vh + 230px);
        }

        .container-fluid{
            margin-top: -100px;
        }
    }
</style>
